import { render, staticRenderFns } from "./setUpNewSecret.popup-chunk.vue?vue&type=template&id=da056040&scoped=true"
import script from "./setUpNewSecret.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./setUpNewSecret.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./setUpNewSecret.popup-chunk.vue?vue&type=style&index=0&id=da056040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da056040",
  null
  
)

export default component.exports